@if (storageLocation(); as lagerplatz) {
  <div class="soft-card border mt-1 p-6 rounded">
    <div class="flex items-center justify-between flex-nowrap">
      <button
        class="flex flex-col justify-start items-start"
        [ngClass]="{ 'cursor-pointer hover:underline': canSelect() }"
        (click)="onOpenSelect()"
      >
        <span class="text-base font-semibold">{{ lagerplatz.lagerplatz }}</span>
        <span class="text-sm text-light">{{ lagerplatz.barcode }}</span>
      </button>
      @if (canScan()) {
        <div class="flex flex-col justify-center align-middle items-center">
          <button class="soft-button primary rounded-full" (click)="onScan()">
            <i class="fa-regular fa-barcode-scan mr-2"></i>
            {{ '#KOMMISSIONIERUNG.PAGES.ARTIKEL_MENGE.CHANGE' | translate }}
          </button>
        </div>
      }
    </div>
  </div>
} @else {
  <div
    class="gap-3"
    [ngClass]="canScan() && canSelect() ? 'grid grid-cols-1 md:grid-cols-2' : 'flex items-center'"
  >
    @if (canScan()) {
      <soft-scan-button
        class="w-full h-full"
        [labelType]="['ean13', 'ean8', 'code39', 'code128', 'itf', 'qrcode']"
      ></soft-scan-button>
    }
    @if (canSelect()) {
      <button
        class="bg-surface border h-full border-solid border-primary rounded p-6 cursor-pointer shadow text-left w-full hover:bg-hover"
        (click)="onOpenSelect()"
      >
        <div class="flex flex-row">
          <div class="flex items-center align-middle">
            <i class="fa-regular fa-shelves fa-3x"></i>
          </div>
          <div class="flex flex-col ml-4">
            <div class="font-semibold text-xl">
              {{ 'Lagerplatz auswählen' | translate }}
            </div>
            <div class="color-light mt-1">
              {{ 'Tippen um manuell einen Lagerplatz auszuwählen' | translate }}
            </div>
          </div>
        </div>
      </button>
    }
  </div>
}
